<template>
    <div class="partners-page">
        <section class="page-header">
            <div class="container">
                <h1 class="page-title">合作伙伴</h1>
                <p class="page-subtitle">与云服务、互联网平台及行业伙伴的长期协作与实践积累</p>
                <div class="breadcrumb">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item>合作伙伴</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>

        <section class="partners-body">
            <div class="container">
                <div class="partners-grid">
                    <article v-for="p in partners" :key="p.id" class="partner-card" data-aos="fade-up">
                        <a :href="p.website" target="_blank" rel="noopener noreferrer" class="card-link">
                            <div class="logo-wrap">
                                <PartnerLogo :logo="p.logo" :name="p.name" />
                            </div>
                            <h2>{{ p.name }}</h2>
                            <p>{{ p.intro }}</p>
                            <span class="visit-hint">访问官网</span>
                        </a>
                    </article>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { partners } from '@/data/partners'
import PartnerLogo from './PartnerLogo.vue'

onMounted(() => {
    AOS.init({ duration: 800, once: true })
})
</script>

<style scoped lang="scss">
.partners-page {
    padding-top: 80px;

    .page-header {
        background: linear-gradient(135deg, #1890ff 0%, #604fdf 100%);
        padding: 56px 0 48px;
        color: #fff;
        margin-bottom: 48px;

        .page-title {
            font-size: 36px;
            margin-bottom: 10px;
        }

        .page-subtitle {
            font-size: 16px;
            opacity: 0.92;
            margin-bottom: 20px;
            max-width: 640px;
            line-height: 1.6;
        }

        .breadcrumb :deep(.el-breadcrumb__inner) {
            color: rgba(255, 255, 255, 0.82);

            &.is-link:hover {
                color: #fff;
            }
        }
    }

    .partners-body {
        padding-bottom: 80px;
    }

    .partners-grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 24px;
    }

    .partner-card {
        background: #fff;
        border-radius: 14px;
        overflow: hidden;
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.07);
        transition: transform 0.25s ease, box-shadow 0.25s ease;

        &:hover {
            transform: translateY(-6px);
            box-shadow: 0 12px 28px rgba(24, 144, 255, 0.12);
        }
    }

    .card-link {
        display: block;
        padding: 24px 20px;
        text-decoration: none;
        color: inherit;
        height: 100%;
    }

    .logo-wrap {
        height: 100px;
        margin-bottom: 16px;
        background: linear-gradient(180deg, #fafbfc 0%, #f0f2f5 100%);
        border-radius: 12px;
    }

    h2 {
        font-size: 18px;
        color: #222;
        margin-bottom: 10px;
        line-height: 1.35;
    }

    .card-link p {
        font-size: 14px;
        color: #666;
        line-height: 1.65;
        margin-bottom: 12px;
        min-height: 3.2em;
    }

    .visit-hint {
        font-size: 13px;
        color: var(--el-color-primary);
        font-weight: 500;
    }
}

@media (max-width: 1200px) {
    .partners-page .partners-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (max-width: 900px) {
    .partners-page .partners-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 520px) {
    .partners-page .partners-grid {
        grid-template-columns: 1fr;
    }

    .partners-page .page-header .page-title {
        font-size: 28px;
    }
}
</style>
